
const WORK = [
  {
    company: "Vosyn",
    positions: [
      {
        position: "Product Lead, Vosyn Core",
        dates: "Jun 2025 - Present",
        description: [
          "Designing and implementing sub-second, low-latency multimodal AI pipelines (audio, video, text), optimizing system architecture for production-scale performance, scalability, and large analysis loops.",
          "Heading product vision and roadmap, translating user interviews, usage metrics, and feedback loops into prioritized features that drive adoption and improve user experience (+18% retention).",
          "Developing and deploying internal AI agents using n8n and fine-tuned open-source models, automating workflows and materially reducing manual operational effort across product teams.",
          "Leading multimodal AI evaluations and benchmarking, identifying capability gaps and guiding iterative improvements across models, prompts, and system architecture.",
          "Designing scalable data schemas, storage patterns, and telemetry pipelines across cloud services, enabling end-to-end observability, traceability, and system reliability."
        ]
      },
      {
        position: "Data Scientist",
        dates: "Mar 2025 - Present",
        description: [
          "Designed and deployed scalable data extraction and cleaning pipelines using containerized microservices",
          "Implemented end-to-end CI/CD/CT pipelines with Kubeflow on Kubernetes, Vertex AI, reducing model deployment time by 70% and streamlining production workflows",
          "Built and optimized inference pipelines on GCP with auto-scaling capabilities, ensuring high-performance model serving for production workloads",
          "Collaborated with product and UX teams to drive process improvements and data pipeline initiatives"
        ]
      }
    ]
  },
  {
    company: "USC Institute for Creative Technologies",
    positions: [
      {
        position: "Research Assistant",
        dates: "Jan 2024 - Feb 2025",
        description: [
          "Conducted research under Dr. Benjamin Nye on Finer Bad Writing: Evaluating LLM Fine-Tuning with LLM-Generated Errors, focused on diagnosing and improving weaknesses in academic writing.",
          "Developed an AI assistant for personalized feedback on college essays, delivering targeted critiques on thesis clarity, argument support, and vagueness.",
          "Designed and executed prompt-engineering frameworks to systematically evaluate, score, and categorize writing issues, ensuring high-quality and actionable feedback.",
          "Fine-tuned and evaluated GPT-3.5, GPT-4, and LLaMA2-7B, emphasizing baseline analysis and automated evaluation methods to improve thesis support and reduce vague reasoning.",
          "Awarded \"Best Data Science Insight\" at Datafirst 2024 for outstanding research insights and technical contributions."
        ]
      }
    ]
  },
  {
    company: "Keck School of Medicine",
    positions: [
      {
        position: "Data Analyst",
        dates: "May 2022 - May 2024",
        description: [
          "Oversaw all marketing channels within the global medicine program, leveraging data insights to drive strategic decisions",
          "Analyzed user behavior and demographic information for detailed targeting to reduce cost per lead by 17% and boost impressions by 36%",
          "Increased conversions by 42% by redesigning digital marketing strategies through optimized A/B testing, keyword research",
          "Recognized growth opportunities by analyzing website data, comprising of over 100k visits per month via SQL queries and hypothesis testing methods",
          "Handled system updates, reconfigurations, troubleshooting, and maintenance to ensure data accuracy and operational efficiency"
        ]
      }
    ]
  },
  {
    company: "Ecom Express",
    positions: [
      {
        position: "Business Analyst Intern",
        dates: "Aug 2020 - Nov 2020",
        description: [
          "Automated labeling creation for 80,000+ item descriptions, enabling migration from unsupervised to supervised learning. Used KMeans clustering to segment data points into categories",
          "Optimized last-mile delivery performance by 10% and minimized shipment returns through predictive modeling of delays, routing analysis, item classification, and optimal placement for new delivery centers",
          "Compiled and visualized data in Excel and Python, identifying actionable insights and presented the findings to the upper management",
          "Partnered with the data engineering team on feature engineering and assisted in managing data pipelines, improving model performance"
        ]
      }
    ]
  }
];

const WorkExperienceSection = () => (
  <section id="work" className="py-20 bg-muted/40">
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="font-playfair text-3xl mb-8 text-primary text-center">Work Experience</h2>
      <ol className="relative border-l-2 border-primary/50 pl-7 space-y-8">
        {WORK.map((company) => (
          <li key={company.company} className="mb-0">
            <div className="bg-card rounded-md border border-border px-5 py-4 shadow-md hover:shadow-lg transition">
              <div className="space-y-4">
                {company.positions.map((position, index) => (
                  <div key={position.position} className={index > 0 ? "border-t border-border pt-4" : ""}>
                    <div className="flex flex-col gap-1">
                      <span className="font-semibold text-lg">
                        {position.position} <span className="text-muted-foreground font-normal">@ {company.company}</span>
                      </span>
                      <span className="text-xs text-muted-foreground ml-0">{position.dates}</span>
                      <ul className="list-disc pl-5 space-y-1 text-base mt-2">
                        {position.description.map((bullet, bulletIndex) => (
                          <li key={bulletIndex}>{bullet}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default WorkExperienceSection;
